import * as React from 'react';
import { useTranslation } from 'react-i18next';
import { InfoListItem, StatusMessage } from '@hvcgroep/design-system';
import { gjtom3 } from '../../helpers/gasCalculation';
import NibudIcon from '../../components/NibudIcon';
import Button from '../../../../shared/components/Button';
import { heatApi } from '../../store/slices/HeatApi';

const NibudDataInfoList = () => {
  const { t } = useTranslation();

  const { data: nibudData, status: nibudStatus } = heatApi.endpoints.getNibudData.useQuery(null);
  const [trigger] = heatApi.endpoints.getNibudData.useLazyQuerySubscription();

  if (nibudStatus === 'rejected' || !nibudData || nibudData.length === 0) {
    return (
      <StatusMessage type="error">
        <p className="mb-4">{t('registration_desk.server_errors.get_nibud')}</p>
        <Button
          variation="center"
          onClick={() => trigger(null)}
        >
          {t('registration_desk.buttons.retry')}
        </Button>
      </StatusMessage>
    );
  }

  const parseValue = (value: string) => {
    return Number(value.replace(',', '.'));
  };

  const nibudDataSorted = [...nibudData].sort((a, b) => {
    return parseValue(a.Value) - parseValue(b.Value);
  });

  return (
    <>
      {nibudDataSorted.map((data, index) => {
        /**
         * The API may return values with commas as decimal separators.
         * This is not a valid number format in JavaScript, so we have to replace commas with dots.
         */

        const gjStart = index === 0 ? parseValue(data.Value) : (parseValue(data.Value) + parseValue(nibudDataSorted[index - 1].Value)) / 2;
        const gjEnd = (parseValue(data.Value) + parseValue(nibudDataSorted[Math.min(index + 1, nibudDataSorted.length - 1)].Value)) / 2;

        return (
          <InfoListItem
            icon={(<NibudIcon nibudType={data.Price_Index_Name} />)}
            title={t(`registration_desk.nibud_title.${data.Price_Index_Name}`)}
            body={t('registration_desk.screens.estimate_explanation.list_item_body', {
              nibudTitle: t(`registration_desk.nibud_title.${data.Price_Index_Name}`), gjStart: Math.floor(gjStart), gjEnd: Math.floor(gjEnd), m3Start: gjtom3(Math.floor(gjStart)), m3End: gjtom3(Math.floor(gjEnd)),
            })}
          />
        );
      })}
    </>
  );
};

export default NibudDataInfoList;
